import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class NotTranslatedProvider {

  notTranslated(key: string) {
    // console.log('<SEM-TRADUCAO>', key + '</SEM-TRADUCAO>');
  }

}
